//
import 'whatwg-fetch';

import { simplApi, simplApiUrl } from '../../api/simplApi';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';

import sha256 from 'fast-sha256';
import { encodeUTF8 } from 'tweetnacl-util';

// ------------------------------------
// Constants
// ------------------------------------
export const LOGIN_STATUS = 'LOGIN_STATUS';
export const LOGOUT = 'LOGOUT';
export const LOGIN_CHECK = 'LOGIN_CHECK';
export const LOGIN_SET = 'LOGIN_SET';
export const LOGIN_FAILED = 'LOGIN_FAILED';

// ------------------------------------
// Actions
// ------------------------------------

export function loginSet(payload) {
  if (typeof payload.token !== 'undefined' && payload.token !== null) {
    localStorage.setItem('token', payload.token);
  }

  if (
    typeof payload.currentAccount !== 'undefined' &&
    payload.currentAccount !== null
  ) {
    localStorage.setItem('currentAccount', payload.currentAccount);
  }

  window.currentAccount = payload.currentAccount;

  return {
    type: LOGIN_SET,
    payload,
  };
}

export function logout() {
  localStorage.clear();
  window.location.href = '/';

  return {
    type: LOGOUT,
  };
}

export function loginFailed() {
  return {
    type: LOGIN_FAILED,
  };
}

export const loginStatus = () => dispatch => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');

  simplApi('me')
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (json.error === 'token_expired') {
          dispatch(addFeedback('error', 'token expired'));
          dispatch(logout());
        } else {
          dispatch(handleApiError(json));
        }
      } else {
        // console.log('fetched my info:', json);
        window.simplUser = json.staff;
        dispatch(loginSet(json));
      }
    });
};

export const loginCheck = (email, password) => dispatch => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');

  // // console.log('checking login');

  const baseUrl = simplApiUrl();

  return fetch(`${baseUrl}auth/token`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      email,
      password,
    }),
  })
    .then(response =>
      response.json().then(json => {
        if (json.status === 'success') {
          // const currentState = history.state;
          dispatch(loginSet(json));
          dispatch(fetchTotalData());
        } else {
          // // console.log('error?');
          dispatch(loginFailed());
        }
      }),
    )
    .catch(err => {
      // // console.log(err);
      dispatch(handleApiError(err));
    });
};

export const switchAccount = accountId => dispatch => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  const options = { method: 'post', body: { simplAccount: accountId } };

  simplApi('switchAccount', options)
    .then(data => data.json())
    .then(json => {
      if (json.status === false) {
        dispatch(logout());
      } else {
        window.location.href = '/dashboard';
        // window.location = `${window.location.origin}/dashboard`;
      }
    });
};

export const saveOnboard = data => dispatch => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  const options = { method: 'post', body: data };

  simplApi('onboard', options).then(() => {
    dispatch(loginStatus());
  });
};

export const forgotPassword = email => () => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');

  const baseUrl = simplApiUrl();

  return fetch(`${baseUrl}auth/forgot`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      email,
    }),
  })
    .then(response =>
      response.json().then(() => {
        // // console.log(json);
      }),
    )
    .catch(err => {
      console.warn(err);
    });
};

export const resetPassword = (
  email,
  password,
  passwordConfirm,
  token,
) => dispatch => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');

  const baseUrl = simplApiUrl();

  return fetch(`${baseUrl}auth/reset`, {
    method: 'post',
    headers,
    body: JSON.stringify({
      email,
      token,
      password,
      password_confirmation: passwordConfirm,
    }),
  })
    .then(response =>
      response.json().then(json => {
        // // console.log('success?', json, email, password);

        if (json.status === 'success') {
          // // console.log('checking login');
          dispatch(loginCheck(email, password));
        }
      }),
    )
    .catch(() => {
      // // console.log(err);
    });
};

export const actions = {
  loginStatus,
  loginCheck,
  loginSet,
  switchAccount,
  forgotPassword,
  resetPassword,
  saveOnboard,
};

const LOGIN_ACTION_HANDLERS = {
  [LOGIN_STATUS]: (state, action) => ({
    ...state,
    user: action.user,
  }),
  [LOGOUT]: state => ({
    ...state,
    fetching: false,
    token: null,
    isAuthenticated: false,
  }),
  [LOGIN_FAILED]: state => ({
    ...state,
    didFail: true,
  }),
  [LOGIN_CHECK]: (state, action) => {
    if (action.type === LOGIN_CHECK) {
      return {
        ...state,
        fetching: true,
        didFail: false,
        email: action.email,
        password: action.password,
      };
    }
    // // console.log('login_check for nothing?');
    return state;
  },
  [LOGIN_SET]: (state, action) => {
    if (action.type === LOGIN_SET) {
      // dispatch(loginSet(json.user, json.staff, json.simplAccounts, json.myCompany, null, json.amIAdmin, json.admin));
      // // console.log('ACTION', action);

      const payload = action.payload;

      window.simplAccount = payload.user.current_simpl_account;

      const Tawk_API = window.Tawk_API || {};

      Tawk_API.visitor = payload.tawk;

      Tawk_API.onLoad = function() {
        Tawk_API.setAttributes(payload.tawk, function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
          const Sentry = window.Sentry || {};
          Sentry.captureException(error);
        });
      };

      if (typeof payload.token !== 'undefined' && payload.token !== null) {
        return {
          ...state,
          fetching: false,
          token: payload.token,
          user: payload.user,
          staff: payload.staff,
          myCompany: payload.myCompany,
          simplAccounts: payload.simplAccounts,
          onboardingDone: payload.onboardingDone,
          amIAdmin: payload.amIAdmin,
          admin: payload.admin,
          isAuthenticated: true,
          didFail: false,
          simplAccount: payload.user.current_simpl_account,
        };
      }

      // // console.log('loginset: ', payload.user.current_simpl_account, state.user.current_simpl_account);
      if (
        typeof state.user !== 'undefined' &&
        state.user !== null &&
        typeof state.user.current_simpl_account !== 'undefined' &&
        state.user.current_simpl_account !== null &&
        state.user.current_simpl_account.length !== 0 &&
        payload.user.current_simpl_account !== state.user.current_simpl_account
      ) {
        // simpl user account switched, lets do a safe refresh
        window.location = `${window.location.origin}/dashboard`;
      }

      return {
        ...state,
        fetching: false,
        user: payload.user,
        staff: payload.staff,
        myCompany: payload.myCompany,
        simplAccounts: payload.simplAccounts,
        onboardingDone: payload.onboardingDone,
        amIAdmin: payload.amIAdmin,
        admin: payload.admin,
        isAuthenticated: true,
        didFail: false,
        simplAccount: payload.user.current_simpl_account,
      };
    }
    return state;
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initState = {
  fetching: false,
  isAuthenticated: false,
  validUntil: 0,
  didFail: false,
  token: null,
  user: {},
  staff: {},
  myCompany: {},
  amIAdmin: false,
  onboardingDone: 1,
  admin: {},
  simplAccount: '',
};
const storageToken = localStorage.getItem('token');

if (typeof storageToken !== 'undefined' && storageToken) {
  initState.token = storageToken;
  initState.isAuthenticated = true;
}

export const initialState = initState;
export default function loginReducer(state = initialState, action) {
  const handler = LOGIN_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js